import { render, staticRenderFns } from "./franchisee.vue?vue&type=template&id=1133145a&scoped=true"
import script from "./franchisee.vue?vue&type=script&lang=js"
export * from "./franchisee.vue?vue&type=script&lang=js"
import style0 from "./franchisee.vue?vue&type=style&index=0&id=1133145a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133145a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1133145a')) {
      api.createRecord('1133145a', component.options)
    } else {
      api.reload('1133145a', component.options)
    }
    module.hot.accept("./franchisee.vue?vue&type=template&id=1133145a&scoped=true", function () {
      api.rerender('1133145a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/franchisee.vue"
export default component.exports